import React, {useContext} from 'react';
import OutputLine from "./OutputLine";
import MobXContext from "../../../app/mobx/MobXContext";
import {observer} from "mobx-react";
import escapeOutputString from "../../../misc/escapeOutputString";
import PropTypes from "prop-types";
import IconTypes from "../Input/IconInput/IconTypes";

const propTypes = {
	baseIndent: PropTypes.number.isRequired,
};
const defaultProps = {};

const SearchOutput = ({baseIndent}) => {
	const {configuratorStore} = useContext(MobXContext);
	const isConfigured = configuratorStore.searchIconType !== IconTypes.none;
	return (
		isConfigured ?
			<>
				<OutputLine indent={baseIndent}>
					{`search: {`}
				</OutputLine>

				{
					configuratorStore.searchTitle ?
						<OutputLine indent={baseIndent + 1} highlightableField="searchTitle">
							{`title: '${escapeOutputString(configuratorStore.searchTitle)}',`}
						</OutputLine>
						: undefined
				}
				{
					((configuratorStore.searchIconType === IconTypes.onClick) && configuratorStore.searchOnClick) ?
						<OutputLine indent={baseIndent + 1} highlightableField="searchOnClick">
							{`onClick: ${configuratorStore.searchOnClick},`}
						</OutputLine>
					: undefined
				}
				{
					((configuratorStore.searchIconType === IconTypes.popupContent) && configuratorStore.searchPlaceholder) ?
						<OutputLine indent={baseIndent + 1} highlightableField="searchPlaceholder">
							{`placeholder: '${escapeOutputString(configuratorStore.searchPlaceholder)}',`}
						</OutputLine>
						: undefined
				}
				{
					((configuratorStore.searchIconType === IconTypes.popupContent) && configuratorStore.searchCallback) ?
						<OutputLine indent={baseIndent + 1} highlightableField="searchCallback">
							{`searchCallback: ${configuratorStore.searchCallback},`}
						</OutputLine>
						: undefined
				}
				{
					configuratorStore.searchShowTitle ?
						<OutputLine indent={baseIndent + 1} highlightableField="searchShowTitle">
							{`showTitle: ${configuratorStore.searchShowTitle},`}
						</OutputLine>
						: undefined
				}

				<OutputLine indent={baseIndent}>
					{`},`}
				</OutputLine>
			</>
			: null
	);
};

SearchOutput.propTypes = propTypes;
SearchOutput.defaultProps = defaultProps;

export default observer(SearchOutput);
